module.exports = __webpack_public_path__ + "img/banderita.df853418.png";